import { FC, PropsWithChildren, useContext, useMemo } from 'react';

import { useParams } from 'react-router-dom';
import ProjectContext, { IProjectContext } from '../../contexts/data/ProjectContext';
import ProjectsContext from '../../contexts/data/ProjectsContext';

export interface IProjectProviderProps {
}

export const ProjectProvider: FC<PropsWithChildren<IProjectProviderProps>> = ({ children }) => {
    const projects = useContext(ProjectsContext);

    const projectId = Number(useParams()?.projectId);

    const project  = useMemo(() => {
        if (!projectId) {
            return {
                data: 
                    (
                        projects.data && 
                        projects.data.length > 0 
                    )
                    ? projects.data[0] 
                    : undefined,
                error: undefined,
                loading: false,
                validating: false,
                refresh: async () => {
                    return undefined;
                },
            } as IProjectContext;
        }

        return {
            data: projects.data?.find(x => x.id === projectId),
            id: projectId,
            error: projects.error,
            loading: projects.loading,
            validating: projects.validating,
            refresh: async () => {
                const newData = await projects.refresh();

                return newData?.find(x => x.id === projectId);
            },
        } as IProjectContext
    }, [projects, projectId]);

    return (

        <ProjectContext.Provider value={project}>
                {children}
        </ProjectContext.Provider>
    );
}

export default ProjectProvider;
